export function hasProperty<T extends string>(
  obj: unknown,
  prop: T,
): obj is Record<T, unknown> {
  return typeof obj === "object" && obj !== null && prop in obj;
}
